export default function PastTense() {
  return (
    <table className="table_sticky">
      <tbody>
        <tr style={{ fontWeight: "bold" }}>
          <th>
            <em>infinitive</em>
          </th>
          <td> děla-ti</td>
          <td> prosi-ti</td>
          <td> nes-ti </td>
        </tr>
        <tr>
          <th> ja (m.), ty (m.), on </th>
          <td> děla-l</td>
          <td> prosi-l</td>
          <td> nes-l</td>
        </tr>
        <tr>
          <th> ja (f.), ty (f.), ona </th>
          <td> děla-la</td>
          <td> prosi-la</td>
          <td> nes-la</td>
        </tr>
        <tr>
          <th> ono, to </th>
          <td> děla-lo</td>
          <td> prosi-lo</td>
          <td> nes-lo</td>
        </tr>
        <tr>
          <th> my, vy, oni </th>
          <td> děla-li </td>
          <td> prosi-li </td>
          <td> nes-li </td>
        </tr>
      </tbody>
    </table>
  )
}
